import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86b7a094"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-nogutter col-12 md:col-8 md:col-offset-2 lg:col-4 lg:col-offset-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "col-12 center" }, "Airidas Dapkevicius", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "col-12 main-image",
  src: "https://i.imgur.com/8t5EDAj.jpg",
  alt: "Airidas Dapkevicius image"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-12 center" }, "A scientist, teacher, photographer, musician, food enthusiast, tech geek and more.", -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]


export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {


/* ------------------- Properties ----------------- */


/* ------------------- Validation ----------------- */


/* ------------------- Methods ----------------- */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, _hoisted_5))
}
}

})